module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLOSSIANS")])])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT:")])]), _vm._v(" With Onesimus as his faithful traveling companion, Paul has written this epistle, sometime after Romans and before the letters to Timothy, in order to strengthen the Colossian church in its time of adversity. Specifically, he urges the Colossians to understand that our approach to God is only through Christ and not through angels. Therefore, in adversity we can know that he is with us through the Spirit, just as he, Paul, is always spiritually, if not physically, present with them (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("   Paul wishes to preserve the Gentile believers in Colossae, whom he has not seen, in order to prevent any submission to the Jewish law as necessary for salvation. His further purpose is to make a clear distinction for them between those things that are necessary to salvation and those that are not (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE")]), _vm._v("). Paul recognizes that believers are vulnerable to temptations from both converted Jews and converted Greeks who acknowledge, for different reasons, the power of angels to confer grace and blessing on humankind (S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERIAN")]), _vm._v("). Paul wishes to show that the greatest danger to Christian discipleship resides in the fact that believers of Jewish background are convincing Gentiles that they should keep the mandates of the law, when in reality Christ the Lord is the giver of salvation through the mystery of the incarnation (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v("). Paul has written to the Colossians in order to overturn the efforts of false apostles, who were teaching them to accept the notion of the divine powers in nature, by which life is supposedly governed, and thus he urges them to accept nothing beyond Christ himself (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Having praised their beginnings in faith, Paul issues a warning that the Colossians not be seduced by philosophy or ceremonies of the law (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS")]), _vm._v(").")])])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b660ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1dev1.vue
// module id = 81
// module chunks = 0